import data from "../../shared/sharedData";

export default {
  modalPrefill: {
    type: "agriculture",
    machine_name: "eta_790a_addendum_b_employment",
    modal_name: "addProfilesModal",
    title: "Agricultural Business Profiles",
    description:
      "Select the Agricultural Business profile(s) to populate in the Addendum B table.",
    isVisible: {
      when: "eta_790a_c7_is_work_addendum_b_completed",
      is: "YES",
    },
  },
  name: "Addendum B - Additional Place of Employment Information",
  pageAlert: {
    widget: "pageAlert",
    alerts: [
      {
        title: "Information Required",
        description:
          "Please specify in Field C.7 whether work will be performed at multiple worksites.",
        type: "info",
        isVisible: {
          when: "eta_790a_c7_is_work_addendum_b_completed",
          is: "untouched",
          operator: "untouched",
        },
      },
      {
        title: "Section Complete",
        description:
          "Because you indicated that work will only be performed at one worksite (per Section C), no Addendum B is necessary for this application.",
        type: "success",
        isVisible: {
          when: "eta_790a_c7_is_work_addendum_b_completed prelim_2_employer_type prelim_3_is_contractor",
          is: [
            ["N/A"],
            ["individual", "association-sole", "association-agent"],
            ["NO"],
          ],
          operator: "compareMultiFieldValuesAND_ORInArray",
        },
      },
    ],
  },
  pageInfo: {
    text: "This addendum must be fully completed and submitted with the Form ETA-790A when the employer needs the workers to perform services or labor required in the agricultural clearance order at additional places of employment other than the place disclosed in Section C, Items 1 through 5.",
    coloring: "grey",
    // read_more: true,
    // character_limit: 212,
    isVisible: {
      when: "eta_790a_c7_is_work_addendum_b_completed prelim_2_employer_type prelim_2_employer_type prelim_3_is_contractor",
      is: "YES joint association-joint YES",
      operator: "compareMultiFieldValuesOR_ISArray",
    },
  },
  sections: [
    {
      code: "Addendum B",
      name: "Additional Places of Employment",
      machine_name: "eta_790a_addendum_b_employment",
      isModal: true,
      removeFromFieldArray: true,
      openModalHeader: "Add Addendum B(C)",
      modalHeader: "Add Additional Places of Employment Information",
      listType: "table",
      validate: ["tableRequired", "tableIncomplete"],
      editButton: true,
      removeLink: "Remove additional place of employment",
      modalFields: [
        {
          machine_name: "business_name",
          label: "Name of Agricultural Business",
          widget: "text",
          validate: ["required", { minLength: 5 }],
          maxLength: 120,
          tooltip:
            "Enter the full legal name and full trade name or DBA name, if applicable, of the agricultural business that will employ workers, or to which labor or services will be provided by workers at the place of employment identified in Items 2 and 3, if applicable.",
        },
        {
          hideOnTable: true,
          machine_name: "employment_address_1",
          label: "Employment Address",
          widget: "text",
          validate: ["required", { minLength: 5 }],
          maxLength: 120,
          tooltip:
            "Enter the street address of the place where work will be performed. The place of employment must be a physical location and cannot be a P.O. box. Employers must disclose, to the best of their knowledge at the time of filing the Form ETA-790A, geographic details related to the place of employment with enough specificity to apprise prospective applicants ofany travel requirements and where they will likely have to reside to perform the services or labor. Although addresses are required, if there is no address, the employer may enter 'No Street Address Available'.",
        },
        {
          hideOnTable: true,
          machine_name: "employment_city",
          label: "City",
          widget: "text",
          validate: [{ minLength: 2 }],
          maxLength: 35,
        },
        {
          machine_name: "employment_state_id",
          label: "State",
          widget: "select",
          selection: data.state,
          state: true,
          validate: ["required"],
        },
        {
          machine_name: "employment_county_id",
          widget: "countyselect",
          label: "County",
          disabled: true,
          parent_machine_name: "add_values_field",
          disableWhenField: "employment_state_id",
          required: true,
          validate: [
            "required",
            {
              required_county: "employment_state_id",
              message: "add_values_field",
              needsFieldValues: true,
            },
          ],
        },
        {
          hideOnTable: true,
          machine_name: "employment_zip",
          widget: "text",
          label: "Postal Code",
          validate: ["postal"],
          maxLength: 10,
          message: "This field cannot be more than 10 characters long.",
        },
        {
          hideOnTable: true,
          machine_name: "additional_info",
          label: "Additional Place of Employment Information",
          widget: "text",
          maxLength: 500,
          tooltip:
            "Enter any additional information about the geographic area of intended employment. Examples may include forest grid identification numbers, GPS coordinates, and/or directions to the place of employment, if applicable. This field will permit an entry of up to 500 characters. If no additional information concerning the place of employment is needed, enter “N/A”in the space provided.",
        },
        {
          hideOnTable: true,
          machine_name: "begin_date",
          widget: "date",
          label: "First Date",
          maxDate: "eta_790a_a4_end_date",
          tooltip:
            "Enter the begin date for the period of intended employment at this place of employment. Use a month/day/year (mm/dd/yyyy) format.",
          validate: [
            "required",
            {
              valueChecker: "begin_date",
              message: "Please fill out A.3 First Date.",
              needsFieldValues: true,
              extraData: {
                valueOf: "eta_790a_a3_begin_date",
                check: "ifValueEmpty",
                prefix: "add_values_field",
                modal: true,
              },
            },
            {
              dateStartEnd: "end_date",
              message: "First Date cannot be after Last Date.",
              needsFieldValues: true,
              extraData: {
                prefix: "add_values_field",
                type: "start",
                currentField: "begin_date",
                isModal: true,
              },
            },
            {
              dateRangeCheck: "begin_date",
              message:
                "Start Date must occur on or within the date range set in A.3 and A.4 in Section A of this job order.",
              needsFieldValues: true,
              extraData: {
                prefix: "add_values_field",
                begin_date: "eta_790a_a3_begin_date",
                end_date: "eta_790a_a4_end_date",
                isModal: true,
              },
            },
          ],
        },
        {
          hideOnTable: true,
          machine_name: "end_date",
          widget: "date",
          label: "Last Date",
          minDate: "eta_790a_a3_begin_date",
          tooltip:
            "Enter the end date for the period of intended employment at this place of employment. Use a month/day/year(mm/dd/yyyy) format.",
          validate: [
            "required",
            {
              valueChecker: "end_date",
              message: "Please fill out A.4 Last Date.",
              needsFieldValues: true,
              extraData: {
                valueOf: "eta_790a_a4_end_date",
                check: "ifValueEmpty",
                prefix: "add_values_field",
                modal: true,
              },
            },
            {
              dateStartEnd: "begin_date",
              message: "Last Date cannot be before First Date",
              needsFieldValues: true,
              extraData: {
                prefix: "add_values_field",
                type: "end",
                currentField: "end_date",
                isModal: true,
              },
            },
            {
              dateRangeCheck: "end_date",
              message:
                "Last Date must occur on or within the date range set in A.3 and A.4 in Section A of this job order.",
              needsFieldValues: true,
              extraData: {
                prefix: "add_values_field",
                begin_date: "eta_790a_a3_begin_date",
                end_date: "eta_790a_a4_end_date",
                isModal: true,
              },
            },
          ],
        },
        {
          hideOnTable: true,
          machine_name: "total_workers",
          widget: "text",
          label: "Total Workers",
          tooltip:
            "Enter the anticipated total number of workers that will be employed at this place of employment.",
          validate: [
            "required",
            {
              minValue: 1,
              message: "Workers Needed must be greater than zero.",
            },
            {
              valueChecker: "total_workers",
              message: "Please fill out A.2A and A.2B.",
              needsFieldValues: true,
              extraData: {
                valueOf: "eta_790a_a2a_workers_needed_total",
                check: "ifValueEmpty",
                prefix: "add_values_field",
                modal: true,
              },
            },
            {
              fieldComparison: "total_workers",
              message:
                "This number should be less than or equal to the total workers needed",
              needsFieldValues: true,
              extraData: {
                operator: "<=",
                valueOf: "eta_790a_a2a_workers_needed_total",
                prefix: "add_values_field",
                modal: true,
              },
            },
          ],
          parse: "positiveWholeNumber",
          maxLength: 4,
        },
      ],
      label:
        "Use the table below to enter the details about  each additional place of employment, when applicable.",
      isVisible: {
        when: "eta_790a_c7_is_work_addendum_b_completed prelim_2_employer_type prelim_2_employer_type prelim_3_is_contractor",
        is: "YES joint association-joint YES",
        operator: "compareMultiFieldValuesOR_ISArray",
      },
    },
  ],
};
